import { FirestoreDataConverter } from '../node_modules/firebase/firestore/dist/firestore';

export default class Agent {
  constructor (
    readonly id: string,
    readonly name: string,
    readonly email: string,
  ) {}

  toString() {
    return this.name;
  }
}

export const AGENT = 'agents';
export const agentConverter: FirestoreDataConverter<Agent> = {
  toFirestore: (agent) => {
    return {
      name: agent.name,
      email: agent.email,
    };
  },

  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options);
    return new Agent(snapshot.id,
      data.name,
      data.email,
    );
  }
};
